import React from 'react';
import {connect} from 'react-redux';
import {submit, startSubmit, isInvalid, isSubmitting} from 'redux-form';

import {MODALS} from 'ducks/bookings';
import {default as Modal, withModal} from 'components/Modal';

import {
  AffordabilityDocumentUploadButtons,
  AffordabilityDocumentUploadForm
} from './components';

import './styles.css';

class AffordabilityDocumentUploadModal extends React.Component<any> {
  submitForm = () => {
    this.props.submit('affordabilityDocumentUpload');
  };

  getExtraActions = () => [...this.props.closeModalExtraActions];

  render() {
    const {
      form: {submitting, invalid},
      data: {agreementUserId, affordabilityId, bookingId}
    } = this.props;

    const submitDisabled = submitting || invalid;

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        type={Modal.MEDIUM}
        className="AffordabilityDocumentUploadModal">
        <Modal.Header heading="Upload a Document" />
        <Modal.Body>
          <AffordabilityDocumentUploadForm
            getExtraActions={this.getExtraActions}
            agreementUserId={agreementUserId}
            bookingId={bookingId}
            affordabilityId={affordabilityId}
            storeDataExtraActions={this.props.storeDataExtraActions}
          />
        </Modal.Body>
        <Modal.Footer>
          <AffordabilityDocumentUploadButtons
            submitForm={this.submitForm}
            submitDisabled={submitDisabled}
            submitting={submitting}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  form: {
    invalid: isInvalid('affordabilityDocumentUpload')(state),
    submitting: isSubmitting('affordabilityDocumentUpload')(state)
  }
});

const mapDispatchToProps = {
  startSubmit,
  submit
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withModal(MODALS.AFFORDABILITY_DOCUMENT_UPLOAD)(
    AffordabilityDocumentUploadModal
  )
);
